import React from 'react';

import { SpecialsPageContentLegacy } from './specials-page-content-legacy';
import { SpecialsPageContentV2 } from './specials-page-content-v2';
import { useSpecialsRedesignEnabled } from './use-specials-redesign-enabled';

export default function SpecialsPage() {
  const specialsRedesignEnabled = useSpecialsRedesignEnabled();

  if (specialsRedesignEnabled) {
    return <SpecialsPageContentV2 />;
  }

  return <SpecialsPageContentLegacy />;
}
